<template>
    <alerts-get
        :page="page"
        v-slot="{
            data: alerts,
            meta,
            error,
            is_loading,
            has_loaded,
            get
        }"
    >
        <div v-if="!has_loaded || error">
            <base-loading
                :error="error"
                :retry="get"
                class="py-6"
            />

            <error-modal
                v-if="error"
                :error="error"
            />
        </div>

        <div v-else>
            <div class="mb-6 bg-white rounded shadow">
                <header class="flex items-center px-4 border-b h-18 sm:px-6">
                    <div class="flex-grow">
                        <h1 class="text-lg font-normal">Alerts</h1>
                    </div>
                    <div class="w-6 h-6 mr-3">
                        <base-svg
                            v-show="is_loading"
                            name="icon-loading"
                            class="w-full h-full fill-current text-grey"
                        />
                    </div>
                </header>

                <template v-if="meta.count > 0">
                    <table-ish>
                        <component
                            v-for="alert in alerts"
                            :is="alert.path ? 'table-ish-row-router-link' : 'table-ish-row'"
                            :key="alert.uuid"
                            :to="{
                                path: alert.path
                            }"
                            class="block mt-2 no-underline md:mt-3"
                        >
                            <table-ish-cell :wrap="true">
                                {{ alert.title }}

                                <div slot="secondary">
                                    {{ alert.description }}
                                </div>
                            </table-ish-cell>

                            <table-ish-cell
                                :shrink="true"
                                class="text-right"
                            >
                                {{ alert.created_at | moment('HH:mm') }}

                                <template slot="secondary">
                                    {{ alert.created_at | moment('D MMM YYYY') }}
                                </template>
                            </table-ish-cell>
                        </component>
                    </table-ish>

                    <footer class="px-4 text-sm font-semibold rounded-b bg-grey-bg sm:px-6 text-grey-darker">
                        <base-pagination
                            v-model="page"
                            :per-page="meta.per_page"
                            :from="meta.from"
                            :to="meta.to"
                            :last-page="meta.last_page"
                            :count="meta.count"
                            :total="meta.total"
                            :is-disabled="is_loading"
                        />
                    </footer>
                </template>

                <div
                    v-else
                    class="relative py-16"
                >
                    <div class="max-w-sm px-6 mx-auto text-center">
                        <h2 class="mb-2 text-xl font-semibold">
                            No alerts found
                        </h2>

                        <div class="text-base text-grey-darker">
                            <p>There's nothing here!</p>

                            <router-link
                                v-if="meta.gross > 0"
                                :to="{
                                    name: $router.fix('dashboard.*.alerts.index')
                                }"
                                class="text-blue"
                            >
                                Reset filters &amp; go to page 1
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </alerts-get>
</template>

<script>
    import PaginationMixin from '../../../../mixins/pagination'
    import AlertsGet from '../../../../components/alerts-get'

    export default {
        mixins: [
            PaginationMixin
        ],
        components: {
            AlertsGet
        }
    }
</script>
